import { FC } from 'react';

import SidebarItem from '../sidebar-item/SidebarItem';

import { ISidebarSection } from '@widgets/sidebar/Sidebar.types';

interface PropsType {
  items: ISidebarSection[];
  parentTitle?: string;
}

const SubMenu: FC<PropsType> = ({ items, parentTitle }) => {
  return (
    <ul
      className="absolute hidden top-[100%] left-[60%] min-w-[210px] 
      bg-white rounded-md border-black z-10 group-hover:block"
    >
      {items.map(item => (
        <div key={item.title} className="">
          <SidebarItem {...item} parentTitle={parentTitle} />
        </div>
      ))}
    </ul>
  );
};

export default SubMenu;
